<template>
  <v-layout row wrap>
    <v-flex md10 xs12>
      <v-btn round block v-on:click="show_time_table = true">
        <v-icon left>event</v-icon>{{ labels.select_time }}
      </v-btn>
    </v-flex>
    <v-flex md2 xs12>
      <v-btn round v-on:click="ExportExcel">{{ labels.save_excel }}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";
import languages from "../../languages/Node.json";
import excel_languages from "../../languages/Excel.json";

export default {
  data: () => ({
    labels: {
      select_time: "",
      save_excel: "",
      course_relevant_info: "",
    },
  }),
  computed: {
    show_time_table: {
      get() {
        return this.$store.state.show_time_table;
      },
      set(value) {
        this.$store.commit("setShowTimeTable", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    ExportExcel: function () {
      var info_data = JSON.parse(JSON.stringify(this.$store.state.info));
      info_data.forEach((element) => {
        element[
          excel_languages.course_code[this.$store.state.select_language.lang]
        ] = element["CourseNo"];
        element[
          excel_languages.course_title[this.$store.state.select_language.lang]
        ] = element["CourseName"];
        element[
          excel_languages.instructor[this.$store.state.select_language.lang]
        ] = element["CourseTeacher"];
        element[
          excel_languages.ge_type[this.$store.state.select_language.lang]
        ] = element["Dimension"];
        element[
          excel_languages.credits[this.$store.state.select_language.lang]
        ] = element["CreditPoint"];
        element[
          excel_languages.required_elective[
            this.$store.state.select_language.lang
          ]
        ] = element["RequireOption"];
        element[
          excel_languages.full_half[this.$store.state.select_language.lang]
        ] = element["AllYear"];
        element[
          excel_languages.ntust_student_registered[
            this.$store.state.select_language.lang
          ]
        ] = element["ChooseStudent"];
        element[
          excel_languages.total_registered[
            this.$store.state.select_language.lang
          ]
        ] = element["AllStudent"];
        element[
          excel_languages.maxi_capacity_for_ntust_preregistration[
            this.$store.state.select_language.lang
          ]
        ] = element["Restrict1"];
        element[
          excel_languages.maxi_capacity_for_ntust_add_drop[
            this.$store.state.select_language.lang
          ]
        ] = element["Restrict2"];
        element[
          excel_languages.ntu_quota[this.$store.state.select_language.lang]
        ] = element["NTURestrict"];
        element[
          excel_languages.ntnu_quota[this.$store.state.select_language.lang]
        ] = element["NTNURestrict"];
        element[
          excel_languages.lecture_hours[this.$store.state.select_language.lang]
        ] = element["CourseTimes"];
        element[
          excel_languages.intern_hours[this.$store.state.select_language.lang]
        ] = element["PracticalTimes"];
        element[
          excel_languages.location[this.$store.state.select_language.lang]
        ] = element["ClassRoomNo"];
        element[excel_languages.time[this.$store.state.select_language.lang]] =
          element["Node"];
        element[excel_languages.notes[this.$store.state.select_language.lang]] =
          element["Contents"];
          
        element[excel_languages.NTNU_People[this.$store.state.select_language.lang]] =
          element["NTNU_People"];
        element[excel_languages.NTU_People[this.$store.state.select_language.lang]] =
          element["NTU_People"];
        element[excel_languages.AbroadPeople[this.$store.state.select_language.lang]] =
          element["AbroadPeople"];

        delete element["total_students"];
        delete element["Semester"];
        delete element["CourseNo"];
        delete element["CourseName"];
        delete element["CourseTeacher"];
        delete element["Dimension"];
        delete element["CreditPoint"];
        delete element["RequireOption"];
        delete element["AllYear"];
        delete element["ChooseStudent"];
        delete element["AllStudent"];
        delete element["Restrict1"];
        delete element["Restrict2"];
        delete element["NTURestrict"];
        delete element["NTNURestrict"];
        delete element["CourseTimes"];
        delete element["PracticalTimes"];
        delete element["ClassRoomNo"];
        delete element["Node"];
        delete element["Contents"];
        delete element["disable"];
        delete element["ThreeNode"];
        delete element["NTNU_People"];
        delete element["NTU_People"];
        delete element["AbroadPeople"];
      });
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(info_data);
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, "out.xlsx");
    },
    setLanguage: function (select_language) {
      this.labels.select_time = languages.select_time[select_language.lang];
      this.labels.course_relevant_info =
        languages.course_relevant_info[select_language.lang];
      this.labels.save_excel = languages.save_excel[select_language.lang];
    },
  },
};
</script>
